package com.cs.ejobin.ui.picker

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import kotlinx.browser.document
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.launch
import org.khronos.webgl.ArrayBuffer
import org.khronos.webgl.Uint8Array
import org.w3c.dom.HTMLInputElement
import org.w3c.files.FileReader

@Composable
actual fun rememberImagePicker(onPicked: (PickedImage) -> Unit): () -> Unit {
    val scope = remember { MainScope() }

    return remember {
        {
            val input = (document.createElement("input") as HTMLInputElement).apply {
                type = "file"
                accept = "image/*"
            }

            input.onchange = {
                val file = input.files?.item(0)
                if (file != null) {
                    val reader = FileReader()

                    reader.onload = {
                        val buffer = reader.result as? ArrayBuffer
                        if (buffer != null) {
                            val uint8 = Uint8Array(buffer)

                            val bytes = ByteArray(uint8.length) { i ->
                                (uint8.asDynamic()[i] as Int).toByte()
                            }

                            val mime = file.type.ifBlank { "image/jpeg" }
                            val ext = when (mime) {
                                "image/png" -> "png"
                                "image/webp" -> "webp"
                                else -> "jpg"
                            }

                            scope.launch {
                                onPicked(
                                    PickedImage(
                                        bytes = bytes,
                                        contentType = mime,
                                        fileExt = ext
                                    )
                                )
                            }
                        }
                        Unit
                    }

                    reader.readAsArrayBuffer(file)
                }
                Unit
            }

            input.click()
        }
    }
}